export const redirectPathnameFromJustLoggedUser = user =>
  user.isSuperAdmin
    ? '/home'
    : '/diagnostiquer'
